import service from './filter.service'
import component from './filter.component'
import './filter.scss'

let module = angular.module('filterModule', ['app.config'])
	.service('Filter', service)
	.component('filters', component)
	.name;

export default module;


// WEBPACK FOOTER //
// ./app/components/filter/filter.js